import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import useQuickTextTemplateConfirmModal from "./useQuickTextTemplateConfirmModal";

const QuickTextTemplateConfirmModal = () => {
  const {
    showConfirmModal,
    templateToDelete,
    isDeleting,
    handleDeleteConfirm,
    handleDeleteCancel,
  } = useQuickTextTemplateConfirmModal();

  return (
    <ConfirmModal
      show={showConfirmModal}
      isConfirming={isDeleting}
      title="Confirm Delete"
      onConfirm={handleDeleteConfirm}
      onCancel={handleDeleteCancel}
      confirmButtonProps={{
        variant: "contained",
        style: {
          color: "#fff",
          backgroundColor: "#EF5350",
        },
      }}
      cancelButtonProps={{
        style: {
          border: "1px solid #969696",
          color: "#969696",
          marginRight: "12px",
        },
      }}
      showContentDivider
      style={{
        ".MuiButtonBase-root": {
          padding: "8px 16px !important",
        },
      }}
    >
      <div style={{ padding: "16px 0" }}>
        You’re about to delete “<b>{templateToDelete?.title}</b>” Deleting this
        will permanently remove it and all related data.
      </div>
    </ConfirmModal>
  );
};

export default QuickTextTemplateConfirmModal;
